var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 1 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8827 11.2929C17.2733 11.6834 17.2733 12.3166 16.8827 12.7071L10.2968 19.293C9.90627 19.6836 9.27311 19.6836 8.88259 19.293C8.49206 18.9025 8.49206 18.2694 8.88259 17.8788L14.7614 12L8.88259 6.12117C8.49206 5.73064 8.49206 5.09748 8.88259 4.70696C9.27311 4.31643 9.90628 4.31643 10.2968 4.70696L16.8827 11.2929Z",
    fill: "currentColor"
  }))));
};
export default SvgArrowRight;